import { useEffect } from "react";

export default function FailureMercadoPago() {
  useEffect(() => {
    (window as any).ReactNativeWebView.postMessage('com.maxdreamapp://url_mp_failure');
  }, [])
  return <h1>Redirigiendo...</h1>
}
